/* eslint-disable tss-unused-classes/unused-classes -- classes are used via returned object from makeStyles hook */
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { COLORS } from '@/styles/tokens/colors';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';
import { BalanceSheetDensity } from '../../BalanceSheetTable.types';

/**
 * Presentation context colors (neutral grayscale for white-labeling)
 */
const PRESENTATION_COLORS = {
  textPrimary: COLORS.NEUTRAL_GRAY[900],
  border: COLORS.NEUTRAL_GRAY[700]
};

/**
 * App context colors
 */
const APP_COLORS = {
  textPrimary: COLORS.TEXT.PRIMARY,
  border: COLORS.GRAY[200]
};

/**
 * Get vertical padding based on density
 */
const getVerticalPadding = (density: BalanceSheetDensity): number => {
  switch (density) {
    case 'default':
      return 12;
    case 'dense':
      return 8;
    case 'extra-dense':
      return 4;
  }
};
export interface BalanceSheetSectionHeaderStyleProps {
  density: BalanceSheetDensity;
  isPresentation: boolean;
}
export const useBalanceSheetSectionHeaderStyles = makeStyles<BalanceSheetSectionHeaderStyleProps>()((_theme: Theme, props) => {
  const {
    density,
    isPresentation
  } = props;
  const colors = isPresentation ? PRESENTATION_COLORS : APP_COLORS;
  const verticalPadding = getVerticalPadding(density);
  return {
    root: {
      display: 'flex',
      alignItems: 'flex-end',
      width: '100%'
    },
    sectionHeader: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      width: 242,
      // Fixed width as per Figma
      paddingTop: verticalPadding,
      paddingBottom: verticalPadding,
      borderBottom: `2px solid ${colors.border}`
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%'
    },
    text: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: FONT_WEIGHTS.bold,
      color: colors.textPrimary,
      textTransform: 'uppercase',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
});